import {
  SlideViewerParentVisit,
  SlideViewerQuiz,
} from '../../slideviewer/SlideViewer';
import ParentVisitButton from '../images/parent-visit-button.png';
import QuizButton from '../images/quiz-button.png';

export default function SlideViewerFooter() {
  return (
    <div className="w-full flex items-end justify-between p-4 absolute bottom-0">
      <div className="flex">
        <SlideViewerQuiz>
          <img
            alt="quiz-button"
            className="h-16 w-16 bg-green-500"
            src={QuizButton}
          />
        </SlideViewerQuiz>

        <SlideViewerParentVisit>
          <img
            alt="parent-visit-button"
            className="h-16 w-16 bg-green-500"
            src={ParentVisitButton}
          />
        </SlideViewerParentVisit>
      </div>
    </div>
  );
}
